<template>
  <div class="animated fadeIn upload-prk">
    <b-card v-if="!showUploadFrm">
      <div slot="header">
        Hasil Migrasi Data Pembayaran Angsuran
        <div class="card-header-actions">
          <button
            class="btn btn-primary mr-1"
            @click="savemigrationdata()"
            :disabled="!saveEnabled"
          >
            <i class="fa fa-save"></i> Save
          </button>
          <button class="btn btn-primary mr-1" @click="cancel()">
            <i class="fa fa-close"></i> {{ $t("cancel") }}
          </button>
        </div>
      </div>
      <b-card no-body>
        <template v-slot:header v-if="filterShow == 'Hide'">
          <b-row>
            <b-col lg="3">
              <b-input-group size="sm" class="mt-1">
                <b-input-group-prepend>
                  <span class="pt-1 mr-1">FILTER</span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="clearFilter"
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
              <b-form-checkbox
                v-model="filterShow"
                value="Hide"
                unchecked-value="Show"
                switch
              >
                <b>{{ filterShow }}</b> Filter
              </b-form-checkbox>
            </b-col>
            <b-col lg="9">
              <b-form-group
                label="FILTER ON :"
                label-cols-sm="1"
                description="Leave all unchecked to filter on all data"
                class="mb-0"
              >
                <b-form-checkbox-group v-model="filterOn" class="mt-1">
                  <b-form-checkbox value="rekonsil"
                    >Rekon Status</b-form-checkbox
                  >
                  <b-form-checkbox value="uraian1"
                    >Description Sub Modul</b-form-checkbox
                  >
                  <b-form-checkbox value="uraian2"
                    >Description GL</b-form-checkbox
                  >
                  <b-form-checkbox value="nilai1"
                    >Value Sub Modul</b-form-checkbox
                  >
                  <b-form-checkbox value="nilai2">Value GL</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </template>
        <b-table
          class="mb-0 text-nowrap"
          ref="tablepembayaranangsuran"
          sticky-header="600px"
          outlined
          responsive
          striped
          hover
          style="font-size: smaller"
          :items="data"
          :fields="tblLcy.fields"
          :current-page="tblLcy.page"
          :per-page="tblLcy.limit"
          :sort-by.sync="tblLcy.sortBy"
          :sort-desc.sync="tblLcy.sortDesc"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
          :tbody-tr-class="rowClass"
        >
          <template v-slot:thead-top="data">
            <b-tr>
              <b-th colspan="10">
                <span class="sr-only">&nbsp;</span>
              </b-th>
              <b-th variant="success" colspan="5" class="text-center"
                >SETTLEMENT TERHADAP JADWAL ANGSURAN</b-th
              >
            </b-tr>
          </template>
          <template v-slot:head(error_text)="data">
            <span
              ><i class="fa fa-exclamation-circle" aria-hidden="true" v-b-tooltip.hover
                title="Baris bermasalah akan ditandai dengan warna kuning"></i
            ></span>
          </template>
          <template v-slot:cell(error_text)="data">
            <span v-if="(data.item.error_text || '') != ''">
              <i
                class="fa fa-exclamation-circle"
                aria-hidden="true"
                v-b-tooltip.hover
                :title="data.item.error_text"
              ></i>
            </span>
          </template>

          <template v-slot:cell(no_kontrak)="data">
            <span
              v-if="
                data.item._cellVariants &&
                data.item._cellVariants.no_kontrak == 'danger'
              "
              v-b-tooltip.hover
              title="No kontrak tidak ada di DATABASE"
              >{{ data.item.no_kontrak }}</span
            >
            <span v-else>{{ data.item.no_kontrak }}</span>
          </template>
          <template v-slot:cell(tglpaym)="data">
            <span v-if="data.item.tglpaym">{{
              data.item.tglpaym | moment("DD-MMM-YYYY")
            }}</span>
          </template>
          <template v-slot:cell(tgl_giro)="data">
            <span v-if="data.item.tgl_giro">{{
              data.item.tgl_giro | moment("DD-MMM-YYYY")
            }}</span>
          </template>
          <template v-slot:cell(totalbyr)="data">{{
            data.item.totalbyr | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(settle_pokok)="data">{{
            data.item.settle_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(settle_bunga)="data">{{
            data.item.settle_bunga | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(settle_denda)="data">{{
            data.item.settle_denda | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(settl_amt)="data">{{
            data.item.settl_amt | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(pbb_amt)="data">{{
            data.item.pbb_amt | numFormat("0,0.00")
          }}</template>

          <template v-slot:custom-foot>
            <b-tr>
              <b-td colspan="10">
                <h6 class="text-right">Total:</h6>
              </b-td>
              <b-td>
                <h6 class="text-right">
                  {{ subtotal.sum_totalbyr | numFormat("0,0.00") }}
                </h6>
              </b-td>
              <b-td> &nbsp; </b-td>
              <b-td> &nbsp; </b-td>
              <b-td> &nbsp; </b-td>
              <b-td>
                <h6 class="text-right">
                  {{ subtotal.sum_settle_pokok | numFormat("0,0.00") }}
                </h6>
              </b-td>
              <b-td>
                <h6 class="text-right">
                  {{ subtotal.sum_settle_bunga | numFormat("0,0.00") }}
                </h6>
              </b-td>
              <b-td>
                <h6 class="text-right">
                  {{ subtotal.sum_settle_denda | numFormat("0,0.00") }}
                </h6>
              </b-td>
              <b-td colspan="2">
                &nbsp;
              </b-td>
            </b-tr>
          </template>
        </b-table>
        <b-row class="mt-2">
          <!-- <b-col lg="8">
            <b-row>
              <b-col cols="6">
                <b-form-checkbox
                  v-model="filterShow"
                  value="Hide"
                  unchecked-value="Show"
                  switch
                  class="ml-2"
                >
                  <b>{{ filterShow }}</b> Filter
                </b-form-checkbox>
                Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to
                    <span
                      v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                    >{{tblLcy.total}}</span>
                    <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} entries,
              </b-col>
              <b-col cols="6">
                <div style="display: flex;margin:0;padding:0;">
                  <div style="margin:0;padding:5px;width:500px; text-align:right;">
                    Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to
                    <span
                      v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                    >{{tblLcy.total}}</span>
                    <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} entries,
                    <span
                      class="mr-1"
                    >limit per page :</span>
                    <select v-model="tblLcy.limit" style="width:60px;">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                      <option>40</option>
                      <option>50</option>
                      <option>60</option>
                      <option>70</option>
                      <option>80</option>
                      <option>90</option>
                    </select>
                  </div>
                  <div>
                    <b-pagination
                      class="ml-1"
                      align="left"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col> -->
          <b-col cols="4">
            <!-- <b-form-checkbox
                  v-model="filterShow"
                  value="Hide"
                  unchecked-value="Show"
                  switch
                  class="ml-2"
                >
                  <b>{{ filterShow }}</b> Filter
                </b-form-checkbox> -->
            Showing {{ (tblLcy.page - 1) * tblLcy.limit + 1 | numFormat}}
            to
            <span v-if="tblLcy.page * tblLcy.limit > tblLcy.total">{{
              tblLcy.total | numFormat
            }}</span>
            <span v-else>{{ tblLcy.page * tblLcy.limit | numFormat}}</span>
            of {{ tblLcy.total | numFormat}} entries,
          </b-col>
          <b-col cols="4">
            <div style="display: flex; margin: 0; padding: 0">
              <div
                style="
                  margin: 0;
                  padding: 5px;
                  width: 500px;
                  text-align: center;
                "
              >
                <!-- Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to
                    <span
                      v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                    >{{tblLcy.total}}</span>
                    <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} entries, -->
                <span class="mr-1">limit per page :</span>
                <select v-model="tblLcy.limit" style="width: 60px">
                  <option>10</option>
                  <option>15</option>
                  <option>20</option>
                  <option>25</option>
                  <option>30</option>
                  <option>40</option>
                  <option>50</option>
                  <option>60</option>
                  <option>70</option>
                  <option>80</option>
                  <option>90</option>
                </select>
              </div>
              <!-- <div>
                    <b-pagination
                      class="ml-1"
                      align="left"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                  </div> -->
            </div>
          </b-col>
          <b-col lg="4">
            <!-- <b-row align-h="right">
              <b-col md="5">
                <b-form-group label="Total Sisa Pokok">
                  <my-number
                    class="form-control text-right"
                    v-model="subtotal.totalModul"
                    :precision="2"
                    disabled
                  ></my-number>
                </b-form-group>
              </b-col>
              <b-col md="5">
                <b-form-group label="Total Sisa Bunga">
                  <my-number
                    class="form-control text-right"
                    v-model="subtotal.totalGl"
                    :precision="2"
                    disabled
                  ></my-number>
                </b-form-group>
              </b-col>
            </b-row> -->
            <div>
              <b-pagination
                class="ml-1"
                align="right"
                :total-rows="tblLcy.total"
                :per-page="tblLcy.limit"
                v-model="tblLcy.page"
              ></b-pagination>
            </div>
          </b-col>
        </b-row>
        <b-row align-h="end">
          <!-- <b-col cols="4">One of two columns</b-col> -->
          <b-col cols="4">
            <!-- <b-card> -->
              <b-input-group>
                <b-input-group-prepend>
                  <label>Jumlah Data Error</label>
                </b-input-group-prepend>
                <span class="form-control-static py-2">: {{subtotal.error | numFormat}} Record</span>
              </b-input-group>
            <!-- </b-card> -->
          </b-col>
        </b-row>
        <b-row v-if="showProgressMigration">
          <b-col>
            <b-alert show variant="warning"
              >Status :
              <strong>{{ progressMigraPembAngsurTemp.status }}</strong>
              <!-- ,Data yang
              berhasil dibaca
              <strong>{{ progressMigrationAngsTemp.value | numFormat }}</strong>
              baris -->
            </b-alert>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <b-row align-h="center" v-else>
      <b-col md="8">
        <b-card>
          <div slot="header">
            Migrasi Data Pembayaran Angsuran
            <div class="card-header-actions">
              <div>
                <b-button class="btn-normal alert mb-2 mr-2" @click="close">
                  <i class="fa fa-times"></i> Close
                </b-button>
              </div>
            </div>
          </div>
          <div v-if="!showProgressMigration">
            <b-input-group>
              <b-input-group-prepend>
                <label>Choose *.XLSX file</label>
              </b-input-group-prepend>
              <b-form-file
                v-model="fileXlsx"
                :state="!$v.fileXlsx.$error"
                placeholder="Choose a XLSX file..."
                drop-placeholder="Drop XLSX file here..."
              ></b-form-file>
            </b-input-group>
            <b-row no-gutters>
              <b-col lg="6">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Nama SHEET</label>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="frmUpload.sheetName"
                    :state="!$v.frmUpload.sheetName.$error"
                  ></b-form-input>
                </b-input-group>
              </b-col>
              <b-col lg="5">
                <b-input-group>
                  <b-input-group-append>
                    <label class="input-group-text ml-1"
                      >Data mulai baris ke-</label
                    >
                  </b-input-group-append>
                  <b-form-input
                    v-model="frmUpload.startRow"
                    type="number"
                    :state="!$v.frmUpload.startRow.$error"
                  ></b-form-input>
                </b-input-group>
              </b-col>
              <b-col lg="12">
                <b-alert :show="showLabelError" variant="danger" class="mt-4">
                  <span v-if="labelErrorTxt != ''">{{ labelErrorTxt }}</span>
                  <b-list-group
                    flush
                    v-if="errorList && errorList.length > 0"
                    style="max-height: 280px; overflow-x: auto"
                  >
                    <b-list-group-item
                      v-for="(item, index) in errorList"
                      :key="index"
                      >Baris : {{ item.baris }}, Kolom : {{ item.kolom }} ,
                      Kesalahan : {{ item.message }}</b-list-group-item
                    >
                  </b-list-group>
                </b-alert>
              </b-col>
            </b-row>
          </div>
          <div v-else>
            <h6 class="text-center">Proses migrasi data pembayaran angsuran</h6>
            <b-progress :max="100" animated>
              <b-progress-bar
                :value="progressMigraPembAngsuran.value"
              ></b-progress-bar>
              <b-progress-bar
                :value="100-(progressMigraPembAngsuran.value)"
                variant="warning"
                :animated="false"
              ></b-progress-bar>
            </b-progress>
            <h6 class="text-center">
              {{ ((progressMigraPembAngsuran.value / 100) * 100).toFixed(2) }}%
            </h6>
          </div>
          <div slot="footer" class="text-center" v-if="!showProgressMigration">
            <b-button variant="primary" @click="importmigrationdata()"
              >Import</b-button
            >
            <b-button variant="danger" @click="close()">Close</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      title="Konfirmasi"
      v-model="confirmCancel"
      @ok="handleCancel"
    >
      <p class="my-2">Apakah anda yakin?</p>
    </b-modal>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>

<style lang="scss" scoped>
.upload-prk {
  iframe {
    border: 1px solid #ccc;
    width: 100%;
    height: 11in;
  }
  .ColsDefine {
    .input-group {
      .input-group-prepend {
        label {
          width: 135px !important;
        }
      }
    }
  }
}
</style>

<script>
import moment from "moment";
// import arreport from "../../apis/arreport";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import klmXls from "../../data/kolomXls";
// import pinjaman from "../../apis/pinjamankredit";
import migration from "../../apis/migration";
import uploadSet from "../../apis/uploadsetting";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmUpload: {
      sheetName: { required },
      startRow: { required },
    },
    fileXlsx: { required },
  },
  data() {
    return {
      showUploadFrm: true,
      showProgressMigration: false,
      fileXlsx: null,
      frmUpload: {
        sheetName: "PEMBAYARAN ANGSURAN",
        startRow: 10,
        no: "A",
        compcode: "B",
        tglpaym: "C",
        paymno: "D",
        uraian: "E",
        jenis: "F",
        nomorcek: "G",
        tgl_giro: "H",
        matauang: "I",
        totalbyr: "J",
        bank_tujuan: "K",
        no_kontrak: "L",
        angsuran_ke: "M",
        settle_pokok: "N",
        settle_bunga: "O",
        settle_denda: "P",
        settl_amt: "Q",
        pbb_amt:'R',
        paym_group:'S'
      },
      showLabelError: false,
      errorList: [],
      labelErrorTxt: "",
      kolomXls: klmXls,
      isLoading: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      //model: { account: "", tgl1: "", tgl2: "" },
      //uanguser: this.$store.state.user.matauang,
      //accounts: [],
      rptLines: [],
      subtotal: {
        sum_totalbyr: 0,
        sum_settle_pokok: 0,
        sum_settle_bunga: 0,
        sum_settle_denda: 0,
        error:0
      },

      filterShow: "Show",
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "error_text",
            label: "",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "no",
            label: "No.",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "compcode",
            label: "Kode Entitas",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "tglpaym",
            label: "Tgl Payment",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "paymno",
            label: "No. Payment",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "uraian",
            label: "Uraian",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "jenis",
            label: "Jenis Payment",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "nomorcek",
            label: "Cek Giro",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "tgl_giro",
            label: "Tgl Giro",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "matauang",
            label: "Mata Uang",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "totalbyr",
            label: "Total Payment",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "bank_tujuan",
            label: "Bank Tujuan",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "no_kontrak",
            label: "No. Kontrak",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "angsuran_ke",
            label: "Angsuran Ke-",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "settle_pokok",
            label: "Settle Pokok",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "settle_bunga",
            label: "Settle Bunga",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "settle_denda",
            label: "Settle Denda",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "settl_amt",
            label: "Settle Amount",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "pbb_amt",
            label: "Prepaid Amount",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "paym_group",
            label: "DEFAULT_STAT",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          
        ],
      },
      filter: null,
      filterOn: [],
      saveEnabled: true,
      confirmCancel: false,
    };
  },
  components: { Loading, myNumber },
  computed: {
    invalidFrmUpload() {
      this.$v.frmUpload.$touch();
      return this.$v.frmUpload.$invalid;
    },
    invalidFileXlsx() {
      this.$v.fileXlsx.$touch();
      return this.$v.fileXlsx.$invalid;
    },
    progressMigraPembAngsurTemp() {
      return this.$store.state.progressMigraPembAngsurTemp;
    },
    progressMigraPembAngsuran() {
      return this.$store.state.progressMigraPembAngsuran;
    },
  },
  watch: {
    progressMigraPembAngsurTemp(val) {
      if (val.status == "Idle") {
        this.showProgressMigration = false;
      }

      if (val.status == "Running") {
        this.showProgressMigration = true;
      }

      if (val.status == "Finish") {
        this.showProgressMigration = false;
        toastr.success("Data selesai dibaca", "", 10000);
        this.saveEnabled = true;
      }
      if (this.$refs.tablepembayaranangsuran) {
        this.$refs.tablepembayaranangsuran.refresh();
      }
    },
    progressMigraPembAngsuran(val) {
      if (val.status == "Idle") {
          this.showProgressMigration = false;
        }

        if (val.status == "Running") {
          this.showProgressMigration = true;
        }

        if (val.status == "Finish") {
          this.showProgressMigration = false;
          toastr.success("Migrasi data telah berhasil", "", 10000);
          this.handleCancel();
        }
    },
  },
  created: async function () {
    // this.$store.commit('progressMigraPembAngsuran',0);
    if (this.$store.state.progressMigraPembAngsuran > 0) {
      this.showProgressMigration = true;
    }
    if (this.$store.state.progressMigraPembAngsuran == 100) {
      this.showProgressMigration = false;
    }
    let getgroupmigrationkey = localStorage.getItem(
      "groupmigrationpembayaranangsurankey"
    );
    let getSheetName = localStorage.getItem("sheetName");
    if (getgroupmigrationkey) {
      this.showUploadFrm = false;
      this.saveEnabled = true;
    }
    // Get setting field from DB
    const setting = await uploadSet.get("upload_migrationpembayaranangsuran");
    for (const key in setting) {
      this.frmUpload[key] = setting[key];
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },
    clearFilter() {
      this.filterOn = [];
      this.filter = "";
    },
    rowClass(item, type) {
      if (item.error_text == "" || item.error_text == null) {
        return;
      }
      return "table-warning";
      // if (!item || type !== 'row') return
      // if (item.status === 'awesome') return 'table-success'
    },
    async data() {
      this.isLoading = true;
      let getgroupmigrationkey = localStorage.getItem(
        "groupmigrationpembayaranangsurankey"
      );
      if (getgroupmigrationkey) {
        this.tblLcy.groupmigrationkey = getgroupmigrationkey;
        this.tblLcy.sheetName = "PEMBAYARAN_ANGSURAN";
        this.tblLcy.sortDir = this.tblLcy.sortDesc ? "desc" : "asc";
        let { list, count } = await migration.getmigrationTEMP(this.tblLcy);
        const subtotal = {};
        for (const key in count) {
          subtotal[key] = count[key];
        }
        this.subtotal = subtotal;
        console.log("#this.subtotal: ", this.subtotal);
        this.isLoading = false;
        return list;
      }
      this.isLoading = false;
      return [];
    },
    async importmigrationdata() {
      if (this.invalidFileXlsx || this.invalidFrmUpload) {
        toastr.error("Please fill the form correctly.");
      } else {
        try {
          this.isLoading = true;
          const {
            list: result,
            groupmigrationkey,
          } = await migration.savemigrationpembayaranangsuranTEMP(
            this.fileXlsx,
            this.frmUpload
          );
          this.saveEnabled = result.filter((x) => x.error == true).length == 0;
          localStorage.setItem(
            "groupmigrationpembayaranangsurankey",
            groupmigrationkey
          );
          this.isLoading = false;
          toastr.success("Background Service Data Migration Started");
          const this_ = this;
          setTimeout(function () {
            this_.isLoading = false;
            this_.showUploadFrm = false;
            this_.showProgressMigration = true;
            this_.saveEnabled = false;
          }, 1000);
          // if (result.length==0) {
          //   toastr.warn("Data is empty");
          // } else {
          //   this.saveEnabled = result.filter(x=>x.error==true).length==0;
          //   localStorage.setItem('groupmigrationpembayaranangsurankey', groupmigrationkey);
          //   localStorage.setItem('sheetName', 'PEMBAYARAN_ANGSURAN');
          // }
          // this.sum(result);
        } catch (error) {
          this.isLoading = false;
          if (error.errSheetList || error.message) {
            this.showLabelError = true;
            this.labelErrorTxt = error.message;
            this.errorList = error.errSheetList;
            this.fileXlsx = null;
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    async savemigrationdata() {
      if (this.tblLcy.total == 0) {
        toastr.warn("Data is empty");
      } else {
        try {
          this.isLoading = true;
          let getgroupmigrationkey = localStorage.getItem(
            "groupmigrationpembayaranangsurankey"
          );
          await migration.savemigrationpembayaranangsuran(getgroupmigrationkey);
          this.showUploadFrm = true;
          // localStorage.removeItem("groupmigrationpembayaranangsurankey");
          // localStorage.removeItem("sheetName");
          toastr.success("Background Service Data Migration Started");
          this.showProgressMigration = true;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      router.push("home");
    },
    cancel() {
      if (!this.saveEnabled) {
        this.handleCancel();
      } else {
        this.confirmCancel = !this.confirmCancel;
      }
    },
    async handleCancel() {
      this.showUploadFrm = true;
      this.rptLines = [];
      await migration.removeDataTEMP({
        tablename: "fin_migration_pembayaran_angsuran",
        groupmigrationkey: localStorage.getItem(
          "groupmigrationpembayaranangsurankey"
        ),
      });
      localStorage.removeItem("groupmigrationpembayaranangsurankey");
      localStorage.removeItem("sheetName");
    },
  },
};
</script>
